// extracted by mini-css-extract-plugin
export var component = "TextContent-module--component--K5phx";
export var oGridBlock = "TextContent-module--o-grid-block--l34M2";